import React, { useCallback } from "react";
import { Task, TaskType } from "../../../types";
import { Button } from "@bandit-network/react-ui-kit";
import { CheckCircledIcon, ExternalLinkIcon } from "@radix-ui/react-icons";
import { getTarget, getUrl } from "../../../utils";
import { useQuestContext } from "../../../context/QuestContext";
import { replaceHyperlinks } from "../../../utils/hyperlink";

export interface PushSubscriptionProps {
  data: Task;
}

const PushSubscription: React.FC<PushSubscriptionProps> = ({ data }) => {
  const { tasksCompleted } = useQuestContext();

  const openPush = useCallback(() => {
    window.open(
      getUrl(TaskType.EPNS_SUBSCRIPTION, data.args.channelAddress),
      getTarget(),
      "height=600,width=600",
    );
  }, [data]);

  const isTaskComplete = tasksCompleted.includes(data?.id);
  return (
    <div className="bad-quest__task">
      <p className="bad-quest__task--description">
        {replaceHyperlinks(data.description)}
      </p>
      <Button
        variant="default"
        size="sm"
        className="bad-quest__task--action_button"
        onClick={openPush}
        disabled={isTaskComplete}
      >
        {isTaskComplete ? `Completed` : `Subscribe`}
        {isTaskComplete ? (
          <CheckCircledIcon className="bad-quest__task--check_icon" />
        ) : (
          <ExternalLinkIcon className="bad-quest__task--link_icon" />
        )}
      </Button>
    </div>
  );
};

export { PushSubscription };
